var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal_time-line hide-print",style:(`transform: translateY(${_vm.translateY}px);`),attrs:{"id":"time-line"}})
}
var staticRenderFns = []

export { render, staticRenderFns }